import { isReleaseTypeBlockchainAuction } from '@utils/product';
import React from 'react';

import {
  ProductPurchaseDetails,
  ProductPurchasingController,
} from '../../../../types/Purchasing';
import { storyblokProductReleaseType } from '../../../../utils/storyblokReleaseType';
import { BlockChainAuctionSubscriptionCta } from './BlockchainAuction';
import { PrivateSubscriptionCta } from './Private';
import { PublicSubscriptionCta } from './Public';
import { SoldOutSubscriptionCta } from './SoldOut';
import { TimedSubscribeCta } from './TimedSubscribe';

type Props<T extends ProductPurchaseDetails> = {
  product: ProductType;
  purchasingController: ProductPurchasingController<T>;
  state: string;
};

export const SubscribeCta: React.FC<Props<ProductPurchaseDetails>> = ({
  product,
  purchasingController,
  state,
}) => {
  const releaseType = storyblokProductReleaseType(product);

  return (
    <>
      {state === 'COMING_SOON' &&
        isReleaseTypeBlockchainAuction(releaseType) && (
          <BlockChainAuctionSubscriptionCta
            product={product}
            purchasingController={purchasingController}
            ranked={releaseType === 'nft_ranked_auction'}
          />
        )}
      {state === 'COMING_SOON' && releaseType === 'public' && (
        <PublicSubscriptionCta
          product={product}
          purchasingController={purchasingController}
        />
      )}
      {state === 'COMING_SOON' && releaseType === 'timed' && (
        <TimedSubscribeCta
          product={product}
          purchasingController={purchasingController}
        />
      )}
      {(state === 'COMING_SOON' || state === 'ENQUIRY') &&
        releaseType === 'private' &&
        product.launchDate && (
          <PrivateSubscriptionCta
            product={product}
            purchasingController={purchasingController}
          />
        )}
      {state === 'SOLD_OUT' && (
        <SoldOutSubscriptionCta
          product={product}
          purchasingController={purchasingController}
        />
      )}
    </>
  );
};
